
import { createRouter, createWebHistory } from 'vue-router';
import storage from './config/storage';

import DashboardLayout from '@/components/_layout/DashboardLayout.vue';
import Login from '@/pages/Login/LoginForm.vue';

import DashboardInfo from '@/pages/Dashboard/DashboardInfo.vue';

import HistoricoList from '@/pages/Historico/HistoricoList.vue';

import ContatoList from '@/pages/Contato/ContatoList.vue';
import ContatoForm from '@/pages/Contato/ContatoForm.vue';

import ListaList from '@/pages/Lista/ListaList.vue';
import ListaForm from '@/pages/Lista/ListaForm.vue';

import EnvioList from '@/pages/Envio/EnvioList.vue';
import EnvioForm from '@/pages/Envio/EnvioForm.vue';
import EnvioSend from '@/pages/Envio/EnvioSend.vue';

import UsuarioList from '@/pages/Usuario/UsuarioList.vue';
import UsuarioForm from '@/pages/Usuario/UsuarioForm.vue';

import DoLogout from '@/pages/Login/DoLogout.vue';

const pageTitle = document.title;

// dashboard routes
const dashRoutes = [

  { name: 'Dashboard', path: '/dashboard', component: DashboardInfo },

  { name: 'Histórico', path: '/historico', component: HistoricoList },

  { name: 'Usuários', path: '/usuarios', component: UsuarioList },
  { name: 'Cadastro do Usuário', path: '/usuarios/f/:id?', component: UsuarioForm },

  { name: 'Contatos', path: '/contatos', component: ContatoList },
  { name: 'Cadastro de Contatos', path: '/contatos/f/:id?', component: ContatoForm },

  { name: 'Listas', path: '/listas', component: ListaList },
  { name: 'Cadastro de Listas', path: '/listas/f/:id?', component: ListaForm },

  { name: 'Envios', path: '/envios', component: EnvioList },
  { name: 'Cadastro de Envios', path: '/envios/f/:id?', component: EnvioForm },
  { name: 'Confirmação de Envio', path: '/enviar/f/:id?', component: EnvioSend }

];

let children = [];
dashRoutes.forEach((item) => {
  children.push({
    path: item.path,
    name: item.name,
    meta: { title: item.name },
    component: item.component
  })
})

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: 'Login' }
  },

  {
    path: '/',
    component: DashboardLayout,
    children
  },
  {
    path: '/sair',
    name: 'Sair',
    component: DoLogout,
    meta: { title: 'Sair' }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: -500, behavior: 'smooth' }; // Rolar para o topo com rolagem suave
    }
  }
});

// Navegar para login se não estiver autenticado
router.beforeEach((to, from, next) => {

  document.title = `${to.meta.title} - ${pageTitle}`;

  const local = 'mail4fly--user';

  if(storage.get(local) && storage.get(local, 'access_token')) {
    console.log('YES! Está logado. =D');

    if(to.path == '/login') next('/dashboard');
  } else {
    console.log('NOP! Não está Logado. :(');

    if(to.path !== '/login' && to.meta.title !== 'Fatura') next('/login');
  }

  next();
});

export default router;
